import { setSettings } from "store/features/memeGenerator/actions";
import { TextBox } from "store/features/memeGenerator/types";
import { useAppDispatch } from "store/store";

export const useItalic = (textBox: TextBox) => {
    const isActive = textBox.decoration.italic;
    const dispatch = useAppDispatch();
    function handleClick() {
        dispatch(
            setSettings({
                id: textBox.id,
                decoration: textBox.decoration
                    ? {
                          ...textBox.decoration,
                          italic: !textBox.decoration.italic,
                      }
                    : {
                          underline: false,
                          bold: false,
                          italic: true,
                      },
            }),
        );
    }
    return { isActive, handleClick };
};
